import { sendGa } from 'reactApp/utils/ga';

export const sendProvocationGa = (action: string, label?: string) => sendGa('upl-provocation', action, label);
